import { httpAnonymousRequest } from 'httpRequest'
import { PublicTenantIdentifierInfoContract } from 'models'

const TENANT_IDENTIFIER_INFO_PREFIX = '/tenant-info'

const tenantIdentifierInfoService = {
    getTenantIdentifierInfo: () =>
        httpAnonymousRequest.get<PublicTenantIdentifierInfoContract>(
            TENANT_IDENTIFIER_INFO_PREFIX,
        ),
}

export default tenantIdentifierInfoService
